import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/home')({
  component: () => <Navigate replace search to="/bo" />,
})
